module.exports = __webpack_public_path__ + "static/media/HowTo1.a91b7799.png";